module.exports = __webpack_public_path__ + "static/media/download.fd47e43e.svg";